import React, { useState, useEffect, useContext, useMemo, useCallback } from 'react'
import { Tooltip } from '@mui/material'
import { BufferService, LoadingContext, M_InputTextField, M_DrawerTableTextField, M_StateActions, NavigateContext, M_CheckBox, M_SimpleTable, M_Button } from 'src/components/M_Components'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import './formsTable.css'

export default function CreateTransportSubResource() {
    const dispatch = useDispatch()
    const M_State = useSelector((state) => state.StateKeyValue)
    const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
    const [dataTransportSubResource, setDataTransportSubResource] = useState(new Map())
    const [optionsTransportSubResource, setOptionsTransportSubResource] = useState([])
    const [transportSubResourceId, setTransportSubResourceId] = useState("")
    const [operation, setOperation] = useState("")
    const [isFirstLoop, setIsFirstLoop] = useState(true)
    const [dataResources, setDataResources] = useState([])
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const bufferServiceTransportSubResource = new BufferService('TransportSubResource')
    const { t } = useTranslation()
    const sessionKeys = ['dataTransportSubResource', 'optionsTransportSubResource', 'transportSubResourceId', 'operation', 'dataResources']

    const columnsResources = [
        { Name: 'ResourceLicense', NormalizedName: t("ResourceLicense"), Type: 'select', ForeignTableToPassId: 'ResourceLicenseId', ForeignKeyName: 'Name', ForeignTableName: 'ResourceLicense' },
        { Name: 'AppliesToDriver', NormalizedName: t("AppliesToDrivers"), Type: 'boolean' },
        { Name: 'AppliesToTrailer', NormalizedName: t("AppliesToTrailers"), Type: 'boolean' },
        { Name: 'AppliesToTransport', NormalizedName: t("AppliesToTransports"), Type: 'boolean' }
    ]

    useEffect(() => {
        if (isFirstLoop) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstLoop(false)
        }
        // eslint-disable-next-line 
    }, [])

    // eslint-disable-next-line 
    useEffect(() => {
        const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        const tempArray = []
        sessionKeys.forEach((key) => {
            tempArray.push(sessionStorageMachine(id, key, key))
        })
        dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))
        // eslint-disable-next-line
    }, [id, dataTransportSubResource, optionsTransportSubResource, transportSubResourceId, operation, dataResources])

    const sessionStorageMachine = (id, key, value) => {
        let tempObj = {}
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (Array.from(eval(value))) }
        } else {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (eval(value)) }
        }
        return tempObj
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
        if (M_StateData) {
            const tempDT = M_StateData.filter(obj => obj.key === `dataTransportSubResource`)[0]?.value
            const tempOT = M_StateData.filter(obj => obj.key === `optionsTransportSubResource`)[0]?.value
            const tempTI = M_StateData.filter(obj => obj.key === `transportSubResourceId`)[0]?.value
            const tempOP = M_StateData.filter(obj => obj.key === `operation`)[0]?.value
            const tempDR = M_StateData.filter(obj => obj.key === `dataResources`)[0]?.value
            if (tempDT || tempOT || tempTI || tempOP || tempDR) {
                setDataTransportSubResource(new Map(tempDT))
                setOptionsTransportSubResource(tempOT)
                setTransportSubResourceId(tempTI)
                setOperation(tempOP)
                setDataResources(tempDR)
                ctx.setIsLoad(false)
                return
            }
        }
        getTransportSubResource()
    }

    const getTransportSubResource = () => {
        const getOperation = ctx.passValue.get('operation')
        const lines = ctx.passValue?.get('lines') || ""
        const getId = lines.Id
        ctx.passValue.delete('operation')
        ctx.passValue.delete('lines')
        ctx.setPassValue(new Map(ctx.passValue))
        setOperation(getOperation)
        setTransportSubResourceId(getId)

        ctx.setIsLoad(true)
        bufferServiceTransportSubResource.options().then((responseOptions) => {
            if (responseOptions.name === 'AxiosError') {
                ctx.toastMessages('error', responseOptions.response.data.Errors[0], '')
                return
            }
            const filteredOptions = responseOptions.filter((option) => !option.IsHiddenList)
            setOptionsTransportSubResource(filteredOptions)

            if (getOperation === 'edit') {
                bufferServiceTransportSubResource.getId(getId).then((response) => {
                    if (response.name === 'AxiosError') {
                        ctx.toastMessages('error', response.response.data.Errors[0], '')
                        ctx2.closeTab(id)
                        return
                    }
                    const valueDataTransportSubResource = response
                    responseOptions.forEach(obj => {
                        dataTransportSubResource.set(obj.Name, valueDataTransportSubResource[obj.Name])
                    })

                    setDataResources(valueDataTransportSubResource.LicenseRequirements || [])
                    setDataTransportSubResource(new Map(dataTransportSubResource))
                    ctx.setIsLoad(false)
                })
            }
        })
        ctx.setIsLoad(false)
    }

    const createStructureResources = useCallback((value, field, index, table) => {
        if (table === 'Resources') {
            setDataResources(line => line.map(prev => {
                if (prev.Id == index) {
                    return { ...prev, [field]: value }
                } return prev
            }))
        }
    }, [setDataResources])

    const headerResources = useMemo(() => columnsResources.map((value, index) => {
        return {
            Id: index + 1,
            header: value.NormalizedName,
            field: value.Name,
            body: (line) => {
                if (value.Type === 'select') {
                    return (
                        <M_DrawerTableTextField
                            tableLabel={value.NormalizedName}
                            required={value.Required}
                            entity={value.ForeignTableName}
                            value={line[value.ForeignTableToPassId] && {
                                [value.ForeignTableToPassId]: line[value.ForeignTableToPassId],
                                [value.ForeignKeyName]: line[value.Name]
                            } || null}
                            filterField={value.ForeignKeyName}
                            labelFields={[value.ForeignKeyName]}
                            onSubmitValue={obj => {
                                if (obj) {
                                    createStructureResources(obj[value.ForeignKeyName] || '', value.Name, line.Id, 'Resources')
                                    createStructureResources(obj[value.ForeignTableToPassId] || '', value.ForeignTableToPassId, line.Id, 'Resources')
                                } else {
                                    createStructureResources('', value.Name, line.Id, 'Resources')
                                    createStructureResources('', value.ForeignTableToPassId, 'Resources')
                                }
                            }}
                            disabled={operation === 'view' ? true : false}
                            valueField={value.ForeignTableToPassId}
                        />
                    )
                } else if (value.Type === 'boolean') {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <M_CheckBox
                                onChange={(e) => createStructureResources(e.target.checked, value.Name, line.Id, 'Resources')}
                                checked={line[value.Name] || false}
                                required={value.IsRequired}
                                noPadding
                            />
                        </div>
                    )
                }
            }
        }
    }), [columnsResources, createStructureResources, t])

    const addResources = () => {
        setDataResources([...dataResources, { Id: dataResources?.length && dataResources[dataResources.length - 1]?.Id + 1 || 0 }])
    }

    const deleteResource = (Id) => {
        setDataResources(prev => prev.filter(obj => obj.Id !== Id))
        ctx.toastMessages('success', '', t("DeleteLine"))
    }

    const transportSubResourceStructure = (event, index) => {
        if (event.type === "date") {
            const dateValue = new Date(event).toISOString().split("T")[0]
            dataTransportSubResource.set(index, dateValue)
        } else {
            dataTransportSubResource.set(index, event)
        }
        setDataTransportSubResource(new Map(dataTransportSubResource))
    }

    const submitTransportSubResource = () => {
        const requiredFieldsTransportSubResource = optionsTransportSubResource.filter((elem) => elem.IsRequired)
        for (const field of requiredFieldsTransportSubResource) {
            if (!dataTransportSubResource.has(field.Name) || !dataTransportSubResource.get(field.Name)) {
                ctx.toastMessages('error', field.NormalizedName, t("RequiredField"))
                return
            }
        }

        dataTransportSubResource.set('LicenseRequirements', dataResources)
        // ctx.setIsLoad(true)

        console.log('Data to submit for TransportSubResource:', Object.fromEntries(dataTransportSubResource))

        if (operation === 'edit') {
            bufferServiceTransportSubResource.update(transportSubResourceId, Object.fromEntries(dataTransportSubResource)).then((response) => {
                if (response.name === 'AxiosError') {
                    ctx.toastMessages("error", '', t("ErrorUpdate"))
                    ctx.setIsLoad(false)
                    return
                }
                ctx.toastMessages("success", '', t("SuccessUpdate"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        } else {
            bufferServiceTransportSubResource.post(Object.fromEntries(dataTransportSubResource)).then((response) => {
                if (response.name === 'AxiosError') {
                    if (response.response.data.Errors[0] === 'DuplicateZoneCode') {
                        ctx.toastMessages("error", '', t(response.response.data.Errors[0]))
                        ctx.setIsLoad(false)
                        return
                    } else {
                        ctx.toastMessages("error", '', t("ErrorCreate"))
                        ctx.setIsLoad(false)
                        return
                    }

                }
                ctx.toastMessages("success", '', t("SuccessCreate"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        }
    }

    return (
        <div className='backgroundForms'>
            <div className="display">
                <div className="menuIcon">
                    <Tooltip title={t("Close")} className='iconsHeaderTable'>
                        <div className='iconsHeaderTable' onClick={() => ctx2.closeTab(id)}>
                            <i className="pi pi-arrow-left iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Close")}</b></span>
                        </div>
                    </Tooltip>
                    <Tooltip title={t("Save")}>
                        <div className='iconsHeaderTable' onClick={submitTransportSubResource}>
                            <i className="pi pi-save iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Save")}</b></span>
                        </div>
                    </Tooltip>
                </div>
            </div>
            <div className='dividerMenu'></div>
            <div className='divFormDriver' style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                <div className='divDisplayFormDriver'>
                    {optionsTransportSubResource.map((elem) => (
                        <div key={elem.Name}>
                            {elem.Type === 'string' ? (
                                < M_InputTextField
                                    type={"text"}
                                    label={elem.NormalizedName}
                                    secondColor={"var(--color-red-dark)"}
                                    required={elem.IsRequired}
                                    onChange={(e) => transportSubResourceStructure(e.target.value, elem.Name)}
                                    value={dataTransportSubResource.get(elem.Name) || ""}
                                />
                            ) : elem.Type === 'boolean' ? (
                                <M_CheckBox
                                    label={elem.NormalizedName}
                                    onChange={(e) => transportSubResourceStructure(e.target.checked, elem.Name)}
                                    checked={dataTransportSubResource.get(elem.Name) || false}
                                    required={elem.IsRequired}
                                    noPadding
                                />
                            ) : ""}
                        </div>
                    ))}
                </div>

                {/* tabela do ADR */}
                <div style={{ padding: '10px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div className='divLabelName'>{t("Resources")}</div>
                        <div>
                            <M_Button
                                label={t("AddResource")}
                                icon={<img src="/icons/svgsDaNet/add-circle.svg"
                                    style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }}
                                    alt="save" />
                                }
                                borderColor={'var(--color-grey)'}
                                onClick={addResources}
                                disabled={operation === 'view' || false}
                            />
                        </div>
                    </div>
                    <div>
                        <M_SimpleTable
                            columns={[
                                ...headerResources,
                                {
                                    body: (line) => {
                                        return (
                                            <div>
                                                <img src="/icons/svgsDaNet/trash-2.svg"
                                                    style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                                                    alt="Delete" className='iconDeleteAddress' onClick={() => deleteResource(line.Id)}
                                                />
                                            </div>
                                        )
                                    }
                                }
                            ]}
                            rows={dataResources}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}